<!-- Overlay backdrop -->
<div class="wizard-overlay"></div>

<!-- Wizard panel -->
<div class="wizard-panel" role="dialog" aria-modal="true">
  <!-- Header -->
  <div class="wizard-header">
    <div class="wizard-progress">
      @for (i of progressSteps; track i) {
        <div
          class="progress-step"
          [class.active]="i === currentStep"
          [class.done]="i < currentStep"
        >
          <span class="step-dot"></span>
        </div>
        @if (i < totalSteps) {
          <div class="progress-line" [class.done]="i < currentStep"></div>
        }
      }
    </div>
    <button class="close-btn" (click)="close()" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <!-- Step content -->
  <div class="wizard-body">
    <h2 class="step-title">{{ stepTitle | translate }}</h2>
    <p class="step-subtitle">{{ stepSubtitle | translate }}</p>

    <!-- ── Step 1: What are you looking for? ── -->
    @if (currentStep === 1) {
      <div class="checkbox-grid">
        @for (option of lookingForOptions; track option.key) {
          <button
            class="option-card checkbox-card"
            [class.selected]="isLookingForSelected(option.key)"
            (click)="toggleLookingFor(option.key)"
            type="button"
          >
            <span class="option-label">{{
              option.translationKey | translate
            }}</span>
            <span
              class="checkbox-box"
              [class.checked]="isLookingForSelected(option.key)"
            >
              @if (isLookingForSelected(option.key)) {
                <svg
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 5L4.5 8.5L11 1"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            </span>
          </button>
        }
      </div>
    }

    <!-- ── Step 2: Do you have a business? ── -->
    @if (currentStep === 2) {
      <div class="radio-list">
        <button
          class="option-card radio-card"
          [class.selected]="form.hasBusiness === 'yes'"
          (click)="form.hasBusiness = 'yes'"
          type="button"
        >
          <div class="radio-text">
            <span class="radio-title">{{
              "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate
            }}</span>
            <span class="radio-desc">{{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_YES_DESCRIPTION"
                | translate
            }}</span>
          </div>
          <span
            class="radio-circle"
            [class.checked]="form.hasBusiness === 'yes'"
          >
            @if (form.hasBusiness === "yes") {
              <svg
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="6" r="3.5" fill="white" />
              </svg>
            }
          </span>
        </button>

        <button
          class="option-card radio-card"
          [class.selected]="form.hasBusiness === 'no'"
          (click)="form.hasBusiness = 'no'"
          type="button"
        >
          <div class="radio-text">
            <span class="radio-title">{{
              "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate
            }}</span>
            <span class="radio-desc">{{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_NO_DESCRIPTION"
                | translate
            }}</span>
          </div>
          <span
            class="radio-circle"
            [class.checked]="form.hasBusiness === 'no'"
          >
            @if (form.hasBusiness === "no") {
              <svg
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="6" r="3.5" fill="white" />
              </svg>
            }
          </span>
        </button>

        <button
          class="option-card radio-card"
          [class.selected]="form.hasBusiness === 'planning'"
          (click)="form.hasBusiness = 'planning'"
          type="button"
        >
          <div class="radio-text">
            <span class="radio-title">{{
              "GENERAL_OUTREACH_FORM.OPTIONS.I_WANT_TO_START_ONE" | translate
            }}</span>
            <span class="radio-desc">{{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_PLANNING_DESCRIPTION"
                | translate
            }}</span>
          </div>
          <span
            class="radio-circle"
            [class.checked]="form.hasBusiness === 'planning'"
          >
            @if (form.hasBusiness === "planning") {
              <svg
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="6" r="3.5" fill="white" />
              </svg>
            }
          </span>
        </button>
      </div>
    }

    <!-- ── Step 3: What help are you looking for? ── -->
    @if (currentStep === 3) {
      <div class="textarea-wrap">
        <textarea
          class="help-textarea"
          [(ngModel)]="form.applicationSummary"
          [placeholder]="
            (form.hasBusiness === 'yes'
              ? 'GENERAL_OUTREACH_FORM.PLACEHOLDERS.APPLICATION_SUMMARY_BUSINESS'
              : 'GENERAL_OUTREACH_FORM.PLACEHOLDERS.APPLICATION_SUMMARY_GENERAL'
            ) | translate
          "
          rows="6"
        ></textarea>
      </div>
    }

    <!-- ── Step 4: Location ── -->
    @if (currentStep === 4) {
      <div class="location-form">
        @if (form.hasBusiness !== "yes") {
          <div class="field-group">
            <label class="field-label" for="wizard-address-line1"
              ><span class="required">*</span>
              {{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.ADDRESS" | translate
              }}</label
            >
            <input
              id="wizard-address-line1"
              type="text"
              class="field-input"
              [(ngModel)]="form.businessAddress"
              [placeholder]="
                'GENERAL_OUTREACH_FORM.PLACEHOLDERS.ENTER_BUSINESS_ADDRESS'
                  | translate
              "
            />
          </div>
        }

        <div class="field-group">
          <label class="field-label" for="wizard-state"
            ><span class="required">*</span>
            {{ "GENERAL_OUTREACH_FORM.FORM_FIELDS.STATE" | translate }}</label
          >
          <app-combobox
            id="wizard-state"
            name="wizard-state"
            [(ngModel)]="form.state"
            [required]="true"
            (ngModelChange)="onStateChange()"
            [options]="states"
            labelKey="name"
            valueKey="name"
            [placeholder]="getStatePlaceholder()"
            [disabled]="isLoadingStates"
            [autoSort]="true"
          ></app-combobox>
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-county"
            ><span class="required">*</span>
            {{ "GENERAL_OUTREACH_FORM.FORM_FIELDS.COUNTY" | translate }}</label
          >
          <app-combobox
            id="wizard-county"
            name="wizard-county"
            [(ngModel)]="form.county"
            [required]="true"
            (ngModelChange)="onCountyChange()"
            [options]="counties"
            labelKey="name"
            valueKey="name"
            [placeholder]="getCountyPlaceholder()"
            [disabled]="
              !form.state || isLoadingCounties || counties.length === 0
            "
            [autoSort]="true"
          ></app-combobox>
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-city"
            ><span class="required">*</span>
            {{ "GENERAL_OUTREACH_FORM.FORM_FIELDS.CITY" | translate }}</label
          >
          <app-combobox
            id="wizard-city"
            name="wizard-city"
            [(ngModel)]="form.city"
            [required]="true"
            (ngModelChange)="onCityChange()"
            [options]="cities"
            labelKey="name"
            valueKey="name"
            [labelFormatter]="formatCityItem"
            [placeholder]="getCityPlaceholder()"
            [disabled]="
              !form.county || isLoadingCounties || cities.length === 0
            "
            [autoSort]="true"
          ></app-combobox>
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-zip"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.ZIP_CODE" | translate
            }}</label
          >
          <app-combobox
            id="wizard-zip"
            name="wizard-zip"
            [(ngModel)]="form.zipCode"
            [required]="true"
            [options]="zipcodes"
            labelKey="code"
            valueKey="code"
            [placeholder]="getZipPlaceholder()"
            [disabled]="
              !form.city || isLoadingZipcodes || zipcodes.length === 0
            "
            [autoSort]="true"
          ></app-combobox>
        </div>
      </div>
    }

    <!-- ── Step 5 (for yes option): Tell us about your business ── -->
    @if (currentStep === 5 && form.hasBusiness === "yes") {
      <div class="business-form">
        <div class="field-group">
          <label class="field-label" for="wizard-business-name"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_NAME" | translate
            }}</label
          >
          <input
            id="wizard-business-name"
            type="text"
            class="field-input"
            [(ngModel)]="form.businessName"
            [placeholder]="
              'GENERAL_OUTREACH_FORM.PLACEHOLDERS.ENTER_BUSINESS_NAME'
                | translate
            "
          />
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-business-address"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ADDRESS" | translate
            }}</label
          >
          <input
            id="wizard-business-address"
            type="text"
            class="field-input"
            [(ngModel)]="form.businessAddress"
            [placeholder]="
              'GENERAL_OUTREACH_FORM.PLACEHOLDERS.ENTER_BUSINESS_ADDRESS'
                | translate
            "
          />
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-display-address">{{
            "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ADDRESS_LINE2"
              | translate
          }}</label>
          <input
            id="wizard-display-address"
            type="text"
            class="field-input"
            [value]="businessAddressLine2"
            readonly
            disabled
          />
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-business-website">{{
            "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_WEBSITE" | translate
          }}</label>
          <input
            id="wizard-business-website"
            type="text"
            class="field-input"
            [(ngModel)]="form.businessWebsite"
            [placeholder]="
              'GENERAL_OUTREACH_FORM.PLACEHOLDERS.ENTER_BUSINESS_WEBSITE'
                | translate
            "
          />
          @if (
            form.businessWebsite &&
            form.businessWebsite.trim().length > 0 &&
            !isWebsiteValid
          ) {
            <span class="field-error">{{
              "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_WEBSITE" | translate
            }}</span>
          }
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-business-type"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_TYPE" | translate
            }}</label
          >
          <select
            id="wizard-business-type"
            class="field-select"
            [(ngModel)]="form.businessType"
          >
            <option value="">
              {{
                "GENERAL_OUTREACH_FORM.OPTIONS.SELECT_BUSINESS_TYPE" | translate
              }}
            </option>
            @for (option of businessTypeOptions; track option.value) {
              <option [value]="option.value">
                {{ option.translationKey | translate }}
              </option>
            }
          </select>
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-business-established"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ESTABLISHED"
                | translate
            }}</label
          >
          <input
            id="wizard-business-established"
            type="text"
            class="field-input"
            [(ngModel)]="form.businessEstablished"
            [placeholder]="
              'GENERAL_OUTREACH_FORM.PLACEHOLDERS.BUSINESS_ESTABLISHED'
                | translate
            "
          />
          @if (
            form.businessEstablished &&
            form.businessEstablished.trim().length > 0
          ) {
            @if (!isBusinessEstablishedFormatValid) {
              <span class="field-error">{{
                "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_BUSINESS_ESTABLISHED_FMT"
                  | translate
              }}</span>
            } @else if (!isBusinessEstablishedNotFuture) {
              <span class="field-error">{{
                "GENERAL_OUTREACH_FORM.VALIDATION.BUSINESS_ESTABLISHED_FUTURE"
                  | translate
              }}</span>
            }
          }
        </div>

        <div class="field-group">
          <label class="field-label" for="wizard-business-employees"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.NUMBER_OF_FTE" | translate
            }}</label
          >
          <input
            id="wizard-business-employees"
            type="number"
            class="field-input"
            [(ngModel)]="form.numberOfEmployees"
            [placeholder]="
              'GENERAL_OUTREACH_FORM.PLACEHOLDERS.ENTER_FTE' | translate
            "
            (keydown)="blockDecimalAndSigns($event)"
            (paste)="blockPasteDecimal($event)"
          />
          @if (
            form.numberOfEmployees !== undefined &&
            form.numberOfEmployees !== null &&
            !isNumberOfEmployeesValid
          ) {
            <span class="field-error">{{
              "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_EMPLOYEES_WHOLE_NUMBER"
                | translate
            }}</span>
          }
        </div>
      </div>
    }

    <!-- ── Step 5 / 6: A few more details ── -->
    @if (
      (currentStep === 5 && form.hasBusiness !== "yes") ||
      (currentStep === 6 && form.hasBusiness === "yes")
    ) {
      <div class="details-form">
        <div class="field-group">
          <label class="field-label" for="wizard-lang"
            ><span class="required">*</span>
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.PREFERRED_LANGUAGE" | translate
            }}</label
          >
          <select
            id="wizard-lang"
            class="field-select"
            [(ngModel)]="form.preferredLanguage"
          >
            @for (lang of languages; track lang.value) {
              <option [ngValue]="lang.value">
                {{ lang.translationKey | translate }}
              </option>
            }
          </select>
        </div>

        <div class="yes-no-group">
          <p class="yn-question">
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.IS_MILITARY_VETERAN"
                | translate
            }}
          </p>
          <div class="yn-cards">
            <button
              class="option-card yn-card"
              [class.selected]="form.isMilitaryVeteran === true"
              (click)="form.isMilitaryVeteran = true"
              type="button"
            >
              <span class="yn-label">{{
                "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate
              }}</span>
              <span
                class="radio-circle"
                [class.checked]="form.isMilitaryVeteran === true"
              >
                @if (form.isMilitaryVeteran === true) {
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3.5" fill="white" />
                  </svg>
                }
              </span>
            </button>
            <button
              class="option-card yn-card"
              [class.selected]="form.isMilitaryVeteran === false"
              (click)="form.isMilitaryVeteran = false"
              type="button"
            >
              <span class="yn-label">{{
                "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate
              }}</span>
              <span
                class="radio-circle"
                [class.checked]="form.isMilitaryVeteran === false"
              >
                @if (form.isMilitaryVeteran === false) {
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3.5" fill="white" />
                  </svg>
                }
              </span>
            </button>
          </div>
        </div>

        <div class="yes-no-group">
          <p class="yn-question">
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.IS_VETERAN_SPOUSE" | translate
            }}
          </p>
          <div class="yn-cards">
            <button
              class="option-card yn-card"
              [class.selected]="form.isVeteranSpouse === true"
              (click)="form.isVeteranSpouse = true"
              type="button"
            >
              <span class="yn-label">{{
                "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate
              }}</span>
              <span
                class="radio-circle"
                [class.checked]="form.isVeteranSpouse === true"
              >
                @if (form.isVeteranSpouse === true) {
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3.5" fill="white" />
                  </svg>
                }
              </span>
            </button>
            <button
              class="option-card yn-card"
              [class.selected]="form.isVeteranSpouse === false"
              (click)="form.isVeteranSpouse = false"
              type="button"
            >
              <span class="yn-label">{{
                "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate
              }}</span>
              <span
                class="radio-circle"
                [class.checked]="form.isVeteranSpouse === false"
              >
                @if (form.isVeteranSpouse === false) {
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3.5" fill="white" />
                  </svg>
                }
              </span>
            </button>
          </div>
        </div>

        <div class="yes-no-group">
          <p class="yn-question">
            {{
              "GENERAL_OUTREACH_FORM.FORM_FIELDS.INTERESTED_IN_CHAMBER_OR_BUSINESS_NETWORKING"
                | translate
            }}
          </p>
          <div class="yn-cards">
            <button
              class="option-card yn-card"
              [class.selected]="isChamberInterestSelected(true)"
              (click)="toggleChamberInterest(true)"
              type="button"
            >
              <span class="yn-label">{{
                "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate
              }}</span>
              <span
                class="radio-circle"
                [class.checked]="isChamberInterestSelected(true)"
              >
                @if (isChamberInterestSelected(true)) {
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3.5" fill="white" />
                  </svg>
                }
              </span>
            </button>
            <button
              class="option-card yn-card"
              [class.selected]="isChamberInterestSelected(false)"
              (click)="toggleChamberInterest(false)"
              type="button"
            >
              <span class="yn-label">{{
                "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate
              }}</span>
              <span
                class="radio-circle"
                [class.checked]="isChamberInterestSelected(false)"
              >
                @if (isChamberInterestSelected(false)) {
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3.5" fill="white" />
                  </svg>
                }
              </span>
            </button>
          </div>
        </div>

        @if (submitError) {
          <p class="submit-error">{{ submitError }}</p>
        }
      </div>
    }
  </div>

  <!-- Footer -->
  <div class="wizard-footer">
    <div class="footer-left">
      @if (currentStep > 1) {
        <button class="btn-back" (click)="back()" type="button">
          {{ "GENERAL_OUTREACH_FORM.BUTTONS.BACK" | translate }}
        </button>
      }
    </div>
    <div class="footer-right">
      <button
        class="btn-next"
        [class.disabled]="!canGoNext"
        [disabled]="!canGoNext || isSubmitting"
        (click)="next()"
        type="button"
      >
        @if (isSubmitting) {
          <span class="spinner"></span>
          {{ "GENERAL_OUTREACH_FORM.BUTTONS.SAVING" | translate }}
        } @else if (currentStep === totalSteps) {
          {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMIT" | translate }}
        } @else {
          {{ "GENERAL_OUTREACH_FORM.BUTTONS.NEXT" | translate }}
        }
      </button>
    </div>
  </div>
</div>
